module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SidebarNavItem', {
    attrs: {
      "classes": _vm.classList.navItem
    }
  }, [_c('a', {
    class: _vm.classList.navLink,
    attrs: {
      "href": _vm.url
    }
  }, [_c('i', {
    class: _vm.classList.icon
  }), _vm._v(" " + _vm._s(_vm.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-53d623f0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarNavLabel.vue
// module id = MNNc
// module chunks = 4